import "./App.css";
import "./css/site.scss";
import React, { useEffect } from "react";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import ScrollToTop from "./Component/ScrollToTop";
import brandConfig from "./config";
import Faqs from "./Component/Faqs";
import CookieBanner from "./Component/CookieBanner";

const MissingPage = () => (
  <main className="page-shell not-found"><span>404</span><h1>That page is off the board.</h1><p>Try the complete game catalogue instead.</p><a className="button" href="/shop">Browse games</a></main>
);

function App() {
  useEffect(() => {
    document.title = `${brandConfig.brandName} · Playable browser games`;
    const description = document.querySelector('meta[name="description"]');
    if (description) description.setAttribute("content", brandConfig.description);
  }, []);
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="*" element={<MissingPage />} />
        </Routes>
        <Footer />
        <CookieBanner />
      </Router>
    </CartProvider>
  );
}

export default App;
